var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CouponList',{attrs:{"from-order":true,"check-coupon":_vm.checkCoupon,"order-coupon-list":_vm.usableCouponList,"unusable-coupon-list":_vm.unusableCouponList},on:{"checkitem":_vm.checkItem,"close":_vm.back,"refreshCoupon":_vm.getCounpon}})}
var staticRenderFns = []

export { render, staticRenderFns }